import React from 'react';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { AiOutlineFieldTime } from 'react-icons/ai';
import { BsCalendarCheck } from 'react-icons/bs';
import { HiDocumentSearch, HiOutlineChip } from 'react-icons/hi';
import RegCityLogo from '../RegCityLogo';

const InfoLogin = () => {
  const textDescription = [
    {
      icon: <AiOutlineFieldTime />,
      text: 'Save time wasted searching regulators’ websites',
    },
    {
      icon: <BsCalendarCheck />,
      text: 'Instant access to the most up to date version',
    },
    {
      icon: <FaCloudDownloadAlt />,
      text: 'No more downloads or scrolling through long documents',
    },
    {
      icon: <HiDocumentSearch />,
      text: 'Search all regulations in a single pass',
    },
    {
      icon: <HiOutlineChip />,
      text: 'Apply AI tools in a secure trusted environment',
    },
  ];

  return (
    <div className='cardCorporate info-text' id='info-text'>
      <RegCityLogo isPlans smallerLogo />
      <p>
        RegulationCity is your single location for every financial services
        regulation - all presented as easy to navigate web pages.
      </p>
      <h3>
        <b>Why choose RegulationCity?</b>
      </h3>
      {textDescription.map((item, index) => {
        return (
          <div key={index} className='features'>
            <div className='features__icon'>{item.icon}</div>
            <b>{item.text}</b>
          </div>
        );
      })}
    </div>
  );
};

export default InfoLogin;
